export const images = [
    {
        img: require("./images//pozadina1.JPG"),
    },

    {
        img: require("./images//IMG_8309.JPG"),
    },
    {
        img: require("./images//pozadina2.JPG"),
    },
    {
        img: require("./images//IMG_8341.JPG"),
    },
    {
        img: require("./images//IMG_8359.JPG"),
    },
];

export const proizvodi = [
    {
        img: require("./images//IMG_8289copy.JPG"),
        naziv: "KOVANE CIGLARSKE PALETE",
    },
    {
        img: require("./images//IMG_8318copy.JPG"),
        naziv: "RAZLIČITE VRSTE BUKOVIH ELEMENATA ",
    },
    {
        img: require("./images//IMG_8342copy.JPG"),
        naziv: "CIJEPANI BUKOV OGREV",
    },
    {
        img: require("./images//IMG_8367.JPG"),
        naziv: "ELEMENTI ZA DRŠKU OD METLE",
    },
    {
        img: require("./images//IMG_8313.JPG"),
        naziv: "BUKOVI OTPADNI OKORCI",
    },
    {
        img: require("./images//IMG_8308.JPG"),
        naziv: "BUKOVE OTPADNE LETVICE",
    },
];

export const Galery = [
    {
        img: require("./images//IMG_8289.JPG"),
    },
    // {
    //     img: require("./images//IMG_8290.JPG"),
    // },
    // {
    //     img: require("./images//IMG_8292.JPG"),
    // },
    {
        img: require("./images//IMG_8301.JPG"),
    },
    {
        img: require("./images//IMG_8304.JPG"),
    },
    // {
    //     img: require("./images//IMG_8305.JPG"),
    // },
    {
        img: require("./images//IMG_8306.JPG"),
    },
    {
        img: require("./images//IMG_8311.JPG"),
    },
    // {
    //     img: require("./images//IMG_8313.JPG"),
    // },
    {
        img: require("./images//IMG_8317.JPG"),
    },
    {
        img: require("./images//IMG_8318.JPG"),
    },
    // {
    //     img: require("./images//IMG_8320.JPG"),
    // },
    // {
    //     img: require('./images//IMG_8329.JPG')
    // },
    // {
    //     img: require('./images//IMG_8330.JPG')
    // },
    // {
    //     img: require('./images//IMG_8331.JPG')
    // },
    // {
    //     img: require('./images//IMG_8337.JPG')
    // },
    {
        img: require('./images//IMG_8339.JPG')
    },
    // {
    //     // img: require('./images//IMG_8342copy.JPG')
    // },
    // {
    //     // img: require('./images//IMG_8345.JPG')
    // },

];
